import React from 'react';
import { Box, Typography } from '@mui/material';

const Instructions = ({ instructions }) => (
  <Box sx={{ mt: 2 }}>
    <Typography variant="h6" gutterBottom>Instructions</Typography>
    <pre style={{ 
      backgroundColor: '#f5f5f5', 
      padding: '16px', 
      borderRadius: '4px',
      margin: 0,
      whiteSpace: 'pre-wrap',
      wordWrap: 'break-word',
      fontSize: '1rem',
    }}>
      {instructions}
    </pre>
    <Typography variant="body2" color="text.secondary" paragraph>
      Click on a stitch in the palette to select it, then click on the grid to place it.
    </Typography>
  </Box>
);

export default Instructions;
